import axios from "@/plugins/axios";

let url = "/api/v1/honja/quizzes";

export default {
    get({ code }) {
        return axios.get(`${url}/${code}`).then((result) => result.data);
    },
};
